import { createStyles } from '../../styles'

export const generalStyles = createStyles({
  menuItem: {
    padding: 1,
  },
  menuText: {
    margin: 0,
  },
})
